import { Box, Typography } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Container = styled(Box)`
  width: 100%;
`

export const ReportHeader = styled(Box)`
  padding: ${theme.spacing.medium}px 0 0 ${theme.spacing.medium}px;
`

export const ReportHeaderTitle = styled('h1')`
  font-size: ${theme.typography.fontSize.xxxLarge};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.menuItemText};
  margin-bottom: ${theme.spacing.large}px;
`

export const SectionTitle = styled(Typography)`
  font-size: ${theme.typography.fontSize.xxLarge};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.menuItemText};
  padding: 0 ${theme.spacing.medium}px 16px;
  margin-bottom: 18px;
  border-bottom: 1px solid ${theme.colors.borderMedium};
`

export const ReportContainer = styled(Box)`
  padding: 0 ${theme.spacing.medium}px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: ${theme.spacing.medium}px;

  @media (max-width: 1023px) {
    justify-content: center;
  }
`
